import React from 'react'

const SingleEmployesRequests = ({
    admin
 ,
    amount
 ,
    created_at
,
    date_from
,
    date_to
,
    days_count
,
    employe
,
    final_response
,
    hours_count
,
    id
,
    image
,
    note
,
    request
,
    sb_employe_id
,
    sb_request_id
,
    status
,
    time_from
,
    time_to



}) => {
  return (
    <tr>
        <td>{id}</td>
        <td>{employe}</td>
         <td>{request}</td>
        <td>{note}</td>
        <td>{date_to}</td>
        <td>{status}</td> 
    </tr>
  )
}

export default SingleEmployesRequests